<template>

<div 
    class="demoted" 
>

    <slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.demoted {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(64px, 1fr));
    grid-gap: 2px;
    padding: 0px 5px;
    margin-bottom: 5px;
}

</style>